module.exports = __webpack_public_path__ + "img/2019_s_np_s_mu.b1a130b8.jpg";